import styled from 'styled-components';

export default styled.div`
    min-height: 140px;
    margin-top: 24px;
`;
